export default import.meta.ROLLDOWN_FILE_URL_Kh58tVt4n5KhrQqpthGlLg